import { FC, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { PrivateHat } from 'src/layout/private-hat';
import { Subject, SUBJECT_SUBCATEGORIES } from 'src/features/feedback/constants/form-options';
import { SubjectItem } from 'src/features/feedback/components/subject-list/parts/subject-item';
import { routes } from 'src/constants/routes';
import {
    SUBJECT_TRANSLATION_KEY,
    SUBJECT_SUBCATEGORY_TRANSLATION_KEY,
} from 'src/features/feedback/constants/translation-keys';
import { SubjectIcon } from 'src/features/feedback/components/subject-list/parts/subject-icon';

export const FeedbackSubcategoryPage: FC = () => {
    const { subject } = useParams<{ subject: Subject }>();
    const { t } = useTranslation();

    if (!subject || !SUBJECT_SUBCATEGORIES[subject]) return null;

    const subcategories = SUBJECT_SUBCATEGORIES[subject]!;

    return (
        <Fragment>
            <PrivateHat title={t(SUBJECT_TRANSLATION_KEY[subject])} backIconText={t('back_cta')} />

            <Stack padding={{ xs: '16px', md: '40px' }} alignItems={{ md: 'center' }}>
                <Typography
                    variant="h2"
                    color="text.primary"
                    marginTop={{ xs: '40px', md: '60px' }}
                >
                    {t('feedback_page_choose-option')}
                </Typography>

                <Stack padding={{ xs: '26px 0', md: '40px 0' }} width="100%" maxWidth="700px">
                    {subcategories.map((subcategory) => {
                        const labelKey =
                            SUBJECT_SUBCATEGORY_TRANSLATION_KEY[subject]?.[subcategory] ||
                            subcategory;
                        const translatedLabel = t(labelKey).toUpperCase();

                        return (
                            <SubjectItem
                                key={subcategory}
                                icon={<SubjectIcon subject={subject} />}
                                titleKey={translatedLabel}
                                link={`${routes.feedback.topics.subcategory
                                    .replace(':subject', subject)
                                    .replace(':subcategory', subcategory)}`}
                            />
                        );
                    })}
                </Stack>
            </Stack>
        </Fragment>
    );
};
